<div
  *ngIf="!sessionId"
  class="bg-m0 flex h-full w-full flex-col items-center justify-center rounded shadow"
>
  <div class="text-xl">Select Session</div>
</div>

<div
  *ngIf="!!sessionId"
  class="bg-m0 flex h-full w-full flex-col rounded shadow"
>
  <div class="flex h-2 w-full flex-grow flex-col overflow-y-auto">
    <ng-scrollbar
      [orientation]="'vertical'"
      [visibility]="'hover'"
      [appearance]="'compact'"
    >
      <div class="ml-4 mt-4 px-6 pb-6 pt-6">
        <!-- Session Section -->
        <div class="mb-8">
          <div class="text-s500 mb-4 flex flex-row justify-start font-semibold">
            Session
          </div>

          <div class="flex flex-col gap-3">
            <div class="grid grid-cols-[auto_1fr] gap-x-4">
              <div class="text-s400 text-base font-medium">Type</div>
              <div class="text-s400 text-base">{{ session?.type || '-' }}</div>
            </div>

            <div class="grid grid-cols-[auto_1fr] gap-x-4">
              <div class="text-s400 text-base font-medium">Status</div>
              <div class="text-s400 text-base">{{
                session?.status === sessionStatusEnum.Archived
                  ? session?.archiveReason === archiveReasonEnum.Expire
                    ? 'Archived (sandbox expired)'
                    : session?.archiveReason === archiveReasonEnum.Commit
                      ? 'Archived (commit by User)'
                      : 'Archived by User'
                  : session?.status === sessionStatusEnum.Paused
                    ? session?.pauseReason === pauseReasonEnum.User
                      ? 'Paused by User'
                      : session?.pauseReason === pauseReasonEnum.Idle
                        ? 'Paused (idle)'
                        : session?.pauseReason === pauseReasonEnum.Safe
                          ? 'Paused (safe)'
                          : session?.pauseReason === pauseReasonEnum.External
                            ? 'Paused (external)'
                            : 'Paused'
                    : session?.status || '-'
              }}</div>
            </div>

            <div class="grid grid-cols-[auto_1fr] gap-x-4">
              <div class="text-s400 text-base font-medium"
                >Codex Subscription</div
              >
              <div class="text-s400 text-base">{{
                session?.providerId === codexProviderId ? 'Enabled' : 'Disabled'
              }}</div>
            </div>

            <div class="grid grid-cols-[auto_1fr] gap-x-4">
              <div class="text-s400 text-base font-medium">Last Activity</div>
              <div class="text-s400 text-base">{{ lastActivityAgo }}</div>
            </div>

            <div class="grid grid-cols-[auto_1fr] gap-x-4">
              <div class="text-s400 text-base font-medium">Created At</div>
              <div class="text-s400 text-base">
                {{ formatTimestamp(session?.createdTs) }}
              </div>
            </div>

            <div class="grid grid-cols-[auto_1fr] gap-x-4">
              <div class="text-s400 text-base font-medium">Env</div>
              <div class="text-s400 text-base">{{ session?.envId || '-' }}</div>
            </div>

            <div class="grid grid-cols-[auto_1fr] gap-x-4">
              <div class="text-s400 text-base font-medium">Branch</div>
              <div class="text-s400 text-base">{{ session?.sessionId }}</div>
            </div>

            <div class="grid grid-cols-[auto_1fr] gap-x-4">
              <div class="text-s400 text-base font-medium">Initial Branch</div>
              <div class="text-s400 text-base">{{
                session?.initialBranch || '-'
              }}</div>
            </div>

            <div class="grid grid-cols-[auto_1fr] gap-x-4">
              <div class="text-s400 text-base font-medium">Initial Commit</div>
              <div class="text-s400 text-base">{{
                session?.initialCommit || '-'
              }}</div>
            </div>
          </div>
        </div>

        <!-- Context Section -->
        <!-- <div class="mb-8">
          <div class="text-s500 mb-4 flex flex-row justify-start font-semibold">
            Context
          </div>

          <div class="flex flex-col gap-3">
            <div class="grid grid-cols-[auto_1fr] gap-x-4">
              <div class="text-s400 text-base font-medium">Provider</div>
              <div class="text-s400 text-base">{{ providerDisplay }}</div>
            </div>

            <div class="grid grid-cols-[auto_1fr] gap-x-4">
              <div class="text-s400 text-base font-medium">Model</div>
              <div class="text-s400 text-base">{{ modelDisplay }}</div>
            </div>

            <div class="grid grid-cols-[auto_1fr] gap-x-4">
              <div class="text-s400 text-base font-medium">Usage</div>
              <div class="text-s400 text-base">{{ usageDisplay }}</div>
            </div>
          </div>
        </div> -->

        <!-- TODOs Section -->
        <div *ngIf="todos.length > 0">
          <div class="text-s500 mb-4 flex flex-row justify-start font-semibold">
            TODOs
          </div>

          <div class="flex flex-col space-y-2">
            <div
              *ngFor="let todo of todos"
              class="flex flex-row items-start space-x-3"
            >
              <div
                class="mt-1 flex h-5 w-5 flex-shrink-0 items-center justify-center"
              >
                <div
                  *ngIf="todo.status === 'completed'"
                  class="bg-s400 flex h-5 w-5 items-center justify-center rounded"
                >
                  <m-check-icon class="text-m0 h-3.5 w-3.5"></m-check-icon>
                </div>

                <div
                  *ngIf="todo.status === 'in_progress'"
                  class="flex h-5 w-5 items-center justify-center"
                >
                  <div class="bg-s400 h-3 w-3 rounded-full"></div>
                </div>

                <div
                  *ngIf="todo.status === 'pending'"
                  class="border-s400 h-5 w-5 rounded border"
                ></div>

                <div
                  *ngIf="todo.status === 'cancelled'"
                  class="border-s400 bg-s200 flex h-5 w-5 items-center justify-center rounded border"
                >
                  <div class="bg-s400 h-[1px] w-2"></div>
                </div>
              </div>

              <span
                class="min-w-0 text-[17px] leading-5"
                [ngClass]="{
                  'text-s400 line-through':
                    todo.status === 'completed' || todo.status === 'cancelled',
                  'text-s1 font-semibold': todo.status === 'in_progress',
                  'text-s1': todo.status === 'pending'
                }"
                >{{ todo.content }}</span
              >
            </div>
          </div>
        </div>

        <div *ngIf="todos.length === 0">
          <div class="text-s500 mb-4 flex flex-row justify-start font-semibold">
            TODOs
          </div>
          <div class="text-s400 text-[17px]">No tasks</div>
        </div>
      </div>
    </ng-scrollbar>
  </div>
</div>

<div *ngIf="session$ | async"></div>
<div *ngIf="todos$ | async"></div>
<div *ngIf="interval$ | async"></div>
